import Smartphones from 'Articles/views/ArticlesImportView/containers/Smartphones'
import Tablets from 'Articles/views/ArticlesImportView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const ArticlesImportView = getCurrentDeviceView(Smartphones, Tablets)

export default ArticlesImportView
